export const normalizeString = (s: string) => s.trim().normalize('NFD')